import React__default from 'react';
import { Table } from './Table.js';

var PaginatedTable = /*#__PURE__*/React__default.forwardRef(function PaginatedTable(props, ref) {
  return React__default.createElement(Table, Object.assign({}, props, {
    disablePagination: false,
    ref: ref
  }));
});

PaginatedTable.Column = function () {
  return null;
};

PaginatedTable.Group = function () {
  return null;
};

export { PaginatedTable };
//# sourceMappingURL=PaginatedTable.js.map
